/*eslint-disable*/

import Me from "../img/PaulCropped.webp";
import Mob from "../img/mobile_ui.gif";
import resume from "../img/PaulVera_Resume.pdf";
import cbc from "../img/cbc.webp";
import tfww from "../img/tfww.webp";
import dlp from "../img/DLP.webp";
import parkway from "../img/parkway.webp";
import projScheduler from "../img/projScheduler.webp";
import passManager from "../img/passManager.webp";
import whiteTooth from "../img/whiteTooth.webp";
import AMG from "../img/AMG.webp";
import chatBot from "../img/ChatBot.png";

export default {
  Me,
  Mob,
  resume,
  cbc,
  tfww,
  dlp,
  parkway,
  projScheduler,
  passManager,
  whiteTooth,
  AMG,
  chatBot
};
